import styled from "styled-components";

export const NewDetailContainerStyled = styled.div`
  padding: 20px 20px 40px 20px;
  .breadcrumb_layout {
    margin-bottom: 30px;
  }
  .new_detail_container {
    margin: auto;
    max-width: ${({ theme }) => theme.ETC.ACTIVITY_DETAIL_WIDTH};
  }

  @media (max-width: ${({ theme }) => theme.SCREENS.SURFACE_DUO}) {
    padding: 32px 20px 40px 20px;
    .breadcrumb_layout {
      display: none;
    }
  }
`;
